import { getConfig } from '~/utils/helpers'

export default function ({ context }) {
  const devUrl = 'https://staging18.staging.gb.ru/api/v2'
  const prodUrl = 'https://gb.ru/api/v2'
  const baseUrl = context.$config.isProd ? prodUrl : devUrl

  return {
    async saveOnboardingData(formData) {
      try {
        await context.$axios.post(
          `${baseUrl}/users/about`,
          formData,
          getConfig(context.$jwt())
        )
      } catch (e) {
        console.warn(e)
      }
    },

    async getStreamsData(type) {
      try {
        const { data } = await context.$axios.get(
          `${baseUrl}/streams/teachers/${type}`,
          getConfig(context.$jwt())
        )

        return data
      } catch (e) {
        console.warn(e)

        return type === 'completed'
          ? {
            averageGrade: null,
            streams: []
          }
          : []
      }
    },

    async getHomeworks(type, params) {
      try {
        const { data } = await context.$axios.get(
          `${baseUrl}/homeworks/${type}`,
          {
            ...getConfig(context.$jwt()),
            params
          }
        )

        return data
      } catch (e) {
        console.warn(e)

        return {}
      }
    },

    async getSearchFields(fieldsUrl) {
      try {
        const { data } = await context.$axios.get(
          `${baseUrl}/user/${fieldsUrl}`,
          getConfig(context.$jwt())
        )

        return data
      } catch (e) {
        console.warn(e)

        return []
      }
    },

    async getSearchOptions(search) {
      try {
        const { data } = await context.$axios.get(
          `${baseUrl}/homeworks/search_options?search=${search}`,
          getConfig(context.$jwt())
        )

        return data
      } catch (e) {
        console.warn(e)

        return []
      }
    },

    async checkTeacher() {
      try {
        const { data } = await context.$axios.get(
          `${baseUrl}/user/teacher_page`,
          getConfig(context.$jwt())
        )

        return data
      } catch (e) {
        console.warn(e)
      }
    },

    async getReportsData(currentPaymentPeriod) {
      try {
        const { data } = await context.$axios.get(
          `${baseUrl}/payments?date=${currentPaymentPeriod}`,
          getConfig(context.$jwt())
        )

        return data
      } catch (e) {
        console.warn(e)

        return {
          amount: null,
          payments: []
        }
      }
    },

    async getFirstPaymentPeriod() {
      try {
        const { data } = await context.$axios.get(
          `${baseUrl}/payments/first_period`,
          getConfig(context.$jwt())
        )

        return data
      } catch (e) {
        console.warn(e)

        return ''
      }
    }
  }
}
